/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountAuthConfig {
    getFixupPrototypeFunction() { return MasterAccountAuthConfig.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountAuthConfig>): MasterAccountAuthConfig {
        let obj = Object.assign(new MasterAccountAuthConfig(), model);
        MasterAccountAuthConfig.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountAuthConfig>): MasterAccountAuthConfig {
        if (!model) return null;
        return MasterAccountAuthConfig.newInstance(<MasterAccountAuthConfig> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountAuthConfig) {
        if (!obj) return;

        models.MasterAccountAuthConfig.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountAuthConfig): boolean {
        Object.setPrototypeOf(obj, MasterAccountAuthConfig.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.domain_info) {
            for (let val of this.domain_info) {
                models.MasterAccountDomainInfo.fixupPrototype(val);
            }
        }
    }

    /**
     * Type of Authentication
     */
    auth_type: string;

    /**
     * Domain information
     */
    domain_info: Array<models.MasterAccountDomainInfo>;

}
